<template>
    <template v-if="risk.featureEnabled">
        <Fieldset>
            <template #legend>
                <h3 class="text-lg font-semibold">{{ $t('Risk insurance') }}</h3>
            </template>
            <div class="border border-slate-200 p-4 rounded-xl space-y-2">
                <label class="flex items-center gap-3">
                    <input type="checkbox" :checked="risk.applied" @change="risk.toggle($event.target.checked)" />
                    <span>
                        {{ $t('I want to add risk cancellation insurance in the amount of') }}
                        <strong>{{ $n(risk.insurance?.amount, 'currency') }}</strong>
                    </span>
                </label>

                <!-- show preview amount when not applied -->
                <div class="text-sm pl-8 text-slate-600">{{ $t('Risk insurance description') }}</div>
            </div>
        </Fieldset>
    </template>
</template>

<script setup>
import { useRiskInsuranceStore } from '@/stores/riskInsurance.js'

const risk = useRiskInsuranceStore()

await risk.loadMeta()
</script>
